export const deliveryClientNameRegex = /^[a-zA-Zа-яА-ЯёЁ ]+$/;
